import { validateEmail } from './validator';

export default ({ email }) => {
  const errors = {};

  if (!email) {
    errors.email = 'Required';
  } else if (!validateEmail(email)) {
    errors.email = 'Wrong email format';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./utils/resetPasswordValidator.js